var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF7A05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2309 3.75344C12.6204 3.85779 12.8299 4.24438 12.7168 4.6663L12.3075 6.19387L13.4922 6.51129L13.9015 4.98372C14.0189 4.54557 14.4054 4.33609 14.8111 4.4448C15.2168 4.5535 15.4101 4.93574 15.297 5.35766L14.8798 6.91474C16.4558 7.54062 17.2309 8.9181 16.8169 10.4633C16.5952 11.2909 16.0836 11.9017 15.3852 12.2363C16.526 12.9768 17.0073 14.1667 16.6507 15.4974C16.155 17.3473 14.4041 18.2348 12.3432 17.6826L12.0179 17.5954L11.6084 19.1236C11.4954 19.5455 11.1369 19.78 10.7312 19.6712C10.3255 19.5625 10.0955 19.1878 10.2129 18.7497L10.6224 17.2215L9.43774 16.9041L9.02826 18.4323C8.91521 18.8542 8.5405 19.0842 8.15103 18.9799C7.74535 18.8712 7.51529 18.4965 7.63269 18.0583L8.04215 16.5302L6.24651 16.0473C5.83064 15.9358 5.58384 15.5083 5.69527 15.0925C5.8067 14.6766 6.23418 14.4298 6.65005 14.5412L8.15475 14.9444L10.2168 7.24858L8.70964 6.84473C8.29376 6.73329 8.04696 6.30582 8.1584 5.88994C8.26983 5.47407 8.6973 5.22727 9.11318 5.3387L10.9118 5.8205L11.3213 4.29236C11.4387 3.85421 11.8253 3.64473 12.2309 3.75344ZM15.0589 10.0792C15.3024 9.17042 14.8411 8.49025 13.8025 8.21197L11.9039 7.70323L11.1299 10.5917L13.0286 11.1005C14.0509 11.3744 14.811 11.0041 15.0589 10.0792ZM9.84289 15.3951L12.6016 16.1343C13.77 16.4473 14.633 16.0177 14.9113 14.9791C15.1895 13.9405 14.6613 13.1207 13.4929 12.8076L10.7343 12.0684L9.84289 15.3951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.add4c8312e85018ad7a727bba6fd5f69.svg";
export { ForwardRef as ReactComponent };